import './bootstrap';

import autoComplete from '@tarekraafat/autocomplete.js';

import.meta.glob([
    '../images/**',
]);

$(document).ready(function() {
    j.init({
        initFunction: function(container) {
            /*
                Per evitare di spaccare il comportamento delle accordion
                caricate dentro le accordion dinamiche
            */
            $('.accordion-item', container).filter(':not(.async-accordion)').on('show.bs.collapse', (e) => {
                e.stopPropagation();
            });

            $('.autocomplete', container).each((index, node) => {
                node = $(node);
                let url = node.attr('data-autocomplete-url');

                const autoCompleteJS = new autoComplete({
                    placeHolder: "Cerca un utente esistente usando il nome o l'indirizzo email",
                    selector: '#' + node.attr('id'),
                    data: {
                        src: async (query) => {
                            try {
                                const source = await fetch(url + '?q=' + query);
                                return await source.json();
                            }
                            catch (error) {
                                return error;
                            }
                        },
                        keys: ["id", "name", "email"],
                        cache: false,
                    },
                    resultItem: {
                        element: (item, data) => {
                            item.innerHTML = `<span>${data.value.name} (${data.value.email})</span>`;
                        },
                    },
                });

                autoCompleteJS.input.addEventListener("selection", function (event) {
                    let select = event.detail.selection.value;
                    $(event.target).val(select.name);
                    $('input[name=user_id]').val(select.id);
                });
            });
        },
    });
});
